import { render } from "./RelationField.vue?vue&type=template&id=788b34eb"
import script from "./RelationField.vue?vue&type=script&lang=js"
export * from "./RelationField.vue?vue&type=script&lang=js"

import "./RelationField.vue?vue&type=style&index=0&id=788b34eb&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__